import { put, call, all, spawn, takeEvery } from "redux-saga/effects";
import { loginServices } from "../services/auth";
import * as types from "../constants/auth";
import * as actions from "../actions/auth";
import * as authReducer from "../reducers/auth";
import * as homeActions from "../actions/home";
import { toast } from "react-toastify";
import images from "../../Constant/images";
import { auth } from "../../Utils/auth";

// Login
function* apiLoginRequestWorker(action) {
  try {
    const result = yield call(loginServices.apiLoginRequest, action);
    // console.log('apiLoginRequestWorker ',result);
    yield put(actions.apiLoginRequestSuccess(result, action));
    let data = {
      id: 0,
      icon: images.dashboard,
      selectedIcon: images.dashboard1,
      title: "Dashboard",
      isSelected: true,
      navigate: "/dashboard",
    };
    yield put(actions.handleSideBarNavigation(data));

    yield put(homeActions.getDashboardRequest());
    toast.success("Login successfully");
  } catch (err) {
    yield put(actions.apiLoginRequestFailed(err, action));
    // console.log('apiLoginRequestWorker err',err?.response?.data?.non_field_errors[0]);
    toast.error(err?.response?.data?.non_field_errors[0]);
  }
}

function* apiLoginRequestWatcher() {
  yield takeEvery(types.API_LOGIN_REQUEST, apiLoginRequestWorker);
}

// refreshToken
function* refreshTokenWorker(action) {
  try {
    let refresh = auth.getRefreshToken();
    let data = { refresh };
    const result = yield call(loginServices.refreshTokenRequest, data);
    yield put(actions.refreshTokenSuccess(result, action));
  } catch (err) {
    console.log("refreshTokenWorker err", err);
    yield put(actions.refreshTokenFailed(err, action));
  }
}

function* refreshTokenWatcher() {
  yield takeEvery(types.REFRESH_TOKEN_REQUEST, refreshTokenWorker);
}

// Signup
function* apiSignupWorker(action) {
  try {
    const result = yield call(loginServices.apiSignupRequest, action);
    yield put(actions.apiSignupSuccess(result, action));
    toast.success("SignUp successfully");
  } catch (err) {
    console.log("apiSignupWorker err", err);
    yield put(actions.apiSignupFailed(err, action));
    // toast.error(err.message);
  }
}

function* apiSignupWatcher() {
  yield takeEvery(types.API_SIGNUP_REQUEST, apiSignupWorker);
}

// Logout
function* apiLogOutRequestWorker(action) {
  try {
    yield call(loginServices.LogoutRequest, action);
    auth.logout();
    // console.log('apiLogOutRequestWorker',);
  } catch (err) {
    console.log("apiLogOutRequestWorker err");
    // yield put(actions.apiLoginRequestFailed(err, action));
    console.log(err);
  }
}

function* apiLogOutRequestWatcher() {
  yield takeEvery(types.LOGOUT_REQUEST, apiLogOutRequestWorker);
}

// Password reset
function* apiPasswordResetRequestWorker(action) {
  try {
    const result = yield call(loginServices.apiPasswordResetRequest, action);
    yield put(actions.apiPasswordResetSuccess(result, action));
    // console.log("apiPasswordResetRequestWorker ", result);
    // toast.success(result?.response?.data?.email[0])
  } catch (err) {
    console.log("apiPasswordResetRequestWorker err", err);
    toast.error(
      err?.response?.data?.email ? err?.response?.data?.email[0] : ""
    );
    yield put(actions.apiPasswordResetFailed(err, action));
  }
}

function* apiPasswordResetRequestWatcher() {
  yield takeEvery(
    types.API_PASSWORD_RESET_REQUEST,
    apiPasswordResetRequestWorker
  );
}

// Password reset confirm
function* apiPasswordResetConfirmRequestWorker(action) {
  try {
    const result = yield call(
      loginServices.apiPasswordResetConfirmRequest,
      action
    );
    yield put(actions.apiPasswordResetConfirmSuccess(result, action));
  } catch (err) {
    yield put(actions.apiPasswordResetConfirmFailed(err, action));
  }
}

function* apiPasswordResetConfirmRequestWatcher() {
  yield takeEvery(
    types.API_PASSWORD_RESET_CONFIRM_REQUEST,
    apiPasswordResetConfirmRequestWorker
  );
}

// getProfile
function* getProfileWorker(action) {
  try {
    const result = yield call(loginServices.getProfileService, action);
    // console.log("getProfile", result);
    yield put(actions.getProfileSuccess(result));
  } catch (err) {
    yield put(actions.getProfileFailed(err));
    console.log("getProfile err", err);
    toast.error("Something went wrong");
  }
}

function* getProfileWatcher() {
  yield takeEvery(types.GET_PROFILE_REQUEST, getProfileWorker);
}

// editProfile
function* editProfileWorker(action) {
  try {
    const result = yield call(loginServices.editProfileService, action);
    // console.log("editProfile", result);
    yield put(actions.editProfileSuccess(result));
    yield put(actions.getProfileRequest());

    toast.success("Profile Updated Successfully!");
  } catch (err) {
    yield put(actions.editProfileFailed(err));
    console.log("editProfile err", err);
    toast.error("Something went wrong");
  }
}

function* editProfileWatcher() {
  yield takeEvery(types.EDIT_PROFILE_REQUEST, editProfileWorker);
}

// Read more information about root sagas in the documentation
// https://redux-saga.js.org/docs/advanced/RootSaga.html
export default function* loginRootSaga() {
  const sagas = [
    apiLoginRequestWatcher,
    apiPasswordResetRequestWatcher,
    apiPasswordResetConfirmRequestWatcher,
    refreshTokenWatcher,
    apiSignupWatcher,
    apiLogOutRequestWatcher,
    getProfileWatcher,
    editProfileWatcher,
  ];

  yield all(
    sagas.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            console.log("error", e);
          }
        }
      })
    )
  );
}
